import { LightType, SceneObjects } from '@types'

export default function isLight(light?: SceneObjects): light is LightType {
  if (!light) return false
  return light?.type === 'lights'
}
